import React from "react";
import { Box, InputLabel, Switch, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface BooleanInputProps {
    label: string;
    value?: boolean;
    isEditing?: boolean;
    onChange?: (value: boolean) => void;
}

const BooleanInput: React.FC<BooleanInputProps> = ({ label, value, isEditing, onChange }) => {
    const { t } = useTranslation("common");

    return (
        <Box>
            <InputLabel
                shrink
                sx={{ fontWeight: 600, letterSpacing: "0.04em", position: "static", transform: "scale(0.75)", transformOrigin: "top left" }}
            >
                {label}
            </InputLabel>
            {isEditing && onChange ? (
                <Switch
                    size="small"
                    checked={value ?? false}
                    onChange={(e) => onChange(e.target.checked)}
                />
            ) : (
                <Typography sx={{ fontWeight: 500, py: 0.5 }}>
                    {value ? t("yes", "Ja") : t("no", "Nein")}
                </Typography>
            )}
        </Box>
    );
};

BooleanInput.defaultProps = {
    value: false,
    isEditing: false,
    onChange: undefined,
};

export default BooleanInput;
